import React, { useEffect } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

interface PaymentSuccessAnimationProps {
  onComplete?: () => void;
}

export function PaymentSuccessAnimation({ onComplete }: PaymentSuccessAnimationProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete?.();
    }, 2500);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 animate-fade-in">
      <div className="relative w-40 h-40 rounded-full backdrop-blur-xl bg-white/10 border border-white/20 shadow-2xl flex items-center justify-center animate-scale-in">
        <div className="w-32 h-32">
          <Player
            autoplay
            keepLastFrame
            src="https://hwjejrsktuenskryvsvl.supabase.co/storage/v1/object/public/applogos/Lottie%20File/Tick%20Interaction%20to%20Show%20Success.json"
            style={{ width: '100%', height: '100%' }}
          />
        </div>
      </div>
    </div>
  );
}
